__turbopack_context__.v({
  "closeButton": "styles-module-scss-module__e8d2Vq__closeButton",
  "descLink": "styles-module-scss-module__e8d2Vq__descLink",
  "feature": "styles-module-scss-module__e8d2Vq__feature",
  "featureBody": "styles-module-scss-module__e8d2Vq__featureBody",
  "featureDesc": "styles-module-scss-module__e8d2Vq__featureDesc",
  "featureIcon": "styles-module-scss-module__e8d2Vq__featureIcon",
  "featureImage": "styles-module-scss-module__e8d2Vq__featureImage",
  "featureList": "styles-module-scss-module__e8d2Vq__featureList",
  "featureName": "styles-module-scss-module__e8d2Vq__featureName",
  "header": "styles-module-scss-module__e8d2Vq__header",
  "inline": "styles-module-scss-module__e8d2Vq__inline",
  "modal": "styles-module-scss-module__e8d2Vq__modal",
  "subtitle": "styles-module-scss-module__e8d2Vq__subtitle",
  "title": "styles-module-scss-module__e8d2Vq__title",
});
